import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import Layout from 'shared/container/Layout';
import { PageError } from 'shared/components';
import LoadableComponent from 'shared/components/LoadableComponent';

const DoList = LoadableComponent(() => import('./Routes/DoList'));

const Job: React.FC<RouteComponentProps> = (props) => {
  const { match } = props;

  return (
    <Layout textHeader="รายการสินค้า">
      <Switch>
        <Route exact path={`${match.path}`} component={DoList} />
        <Route component={PageError} />
      </Switch>
    </Layout>
  );
};

export default Job;
